<template>
  <el-dialog title="Adicionar Observação" @open="open" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" :modal-append-to-body="false" width="50%">
    <el-form ref="form" :model="observacao" :rules="validacao" size="small" label-position="top" hide-required-asterisk	:show-message="false">
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="Data/Hora" prop="dataHora">
            <el-input v-model="observacao.dataHora" v-mask="'##/##/#### ##:##'" readonly/>
          </el-form-item>
        </el-col>

        <el-col :span="18">
          <el-form-item label="Usuário">
            <el-input v-model="observacao.usuario.nome" readonly/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col>
          <el-form-item label="Assunto">
            <el-input v-model="observacao.assunto" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row style="height: 350px;">
        <el-col :span="24" style="height: 100%;">
          <el-form-item label="Descrição" prop="descricao" class="obs-form-item" style="height: 100%;">
            <el-input
              v-model="observacao.descricao"
              type="textarea"
              style="height: 100%"
              class="obs-text-area "
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="gravarHandler" type="success" size="small" round class="btn-box-shadow">Confirmar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";

import Util from "../../util/funcoes.js";
import { validadorDataHora } from "../../util/validadores.js";

export default {
  props: {
    visibility: Boolean,
    observacaoSelecionada: Object,
    tipo: String
  },
  data() {
    return {
      validacao: {
        dataHora: [
          { validator: validadorDataHora, trigger: 'blur' }
        ],
        descricao: [
          { type: "string", required: true, whitespace: true, trigger: 'blur' }
        ]
      },
      observacao: {
        dataHora: Util.agora(),
        descricao: "",
        assunto: "",
        usuario: ""
      }
    };
  },
  computed: {
    ...mapState('loginStore', {
      usuarioLogado(state) { return state.usuarioLogado }
    }),
    // ALUGUEL
    ...mapState('alugueisContratosStore', {
      aluguel(state) { return state.aluguelSelecionado }
    }),
    ...mapState("alugueisImoveisStore", {
      imovelAluguel(state) { return state.imovelSelecionado; }
    }),
    ...mapState("alugueisClientesStore", {
      clienteAluguel(state) { return state.clienteSelecionado; }
    }),
    // VENDA
    ...mapState("vendasClientesStore", {
      cliente(state) { return state.clienteSelecionado; }
    }),
    ...mapState("vendasImoveisStore", {
      imovel(state) { return state.imovelSelecionado; }
    }),
    ...mapState('vendasContratosStore', {
      venda(state) { return state.vendaSelecionada }
    }),
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    // ALUGUEL
    ...mapActions('alugueisContratosStore', [
      'gravarObservacaoAluguel'
    ]),
    ...mapActions('alugueisImoveisStore', {
      gravarObservacaoImovelAluguel: 'gravarObservacaoImovel'
      }),
    ...mapActions('alugueisClientesStore', {
      gravarObservacaoClienteAluguel: 'gravarObservacaoCliente'
      }),
    // VENDA
    ...mapActions('vendasImoveisStore', [
      'gravarObservacaoImovel'
    ]),
    ...mapActions('vendasClientesStore', [
      'gravarObservacaoCliente'
    ]),
    ...mapActions('vendasContratosStore', [
      'gravarObservacaoVenda'
    ]),
    gravarHandler() {
      this.$refs['form'].validate((valid) => {
        if(valid) {
          this.gravar();
        } else {
          this.$message.error("Preencha todos os campos obrigatórios");
        }
      });
    },
    gravar() {
      switch(this.tipo) {
        // ALUGUEL
        case "ALUGUEL":
          this.gravarObservacoesDoAluguel(this.observacao);
          break;
        case "IMOVEL_ALUGUEL":
          this.gravarObservacaoDoImovelAluguel(this.observacao);
          break;
        case "CLIENTE_ALUGUEL":
          this.gravarObservacaoDoClienteAluguel(this.observacao);
          break;
        // VENDA
        case "CLIENTE":
          this.gravarObservacaoDoCliente(this.observacao);
          break;
        case "IMOVEL":
          this.gravarObservacaoDoImovel(this.observacao);
          break;
        case "VENDA":
          this.gravarObservacoesDaVenda(this.observacao);
          break;
      }
    },
    gravarObservacoesDoAluguel(payload) {
      payload.aluguel = { id: this.aluguel.id };

      this.showLoading();
      this.gravarObservacaoAluguel(payload)
        .then(resultado => {
          this.hideLoading();

          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.fechar();
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
          }
        })
        .catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível comunicar-se com o servidor");
        });
    },
    gravarObservacaoDoImovelAluguel(payload) {
      payload.imovel = { id: this.imovelAluguel.id };
        
      this.showLoading();
      this.gravarObservacaoImovelAluguel(payload)
      .then((resultado) => {
        this.hideLoading();

        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.fechar();
            break;
          case "FALHA":
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível comunicar-se com o servidor");
      });
    },
    gravarObservacaoDoClienteAluguel(payload) {
      payload.cliente = { id: this.clienteAluguel.id };
        
      this.showLoading();
      this.gravarObservacaoClienteAluguel(payload)
      .then((resultado) => {
        this.hideLoading();

        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.fechar();
            break;
          case "FALHA":
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível comunicar-se com o servidor");
      });
    },
    //  VENDA
    gravarObservacaoDoCliente(payload) {
      payload.cliente = { id: this.cliente.id };

      this.showLoading();
      this.gravarObservacaoCliente(payload)
        .then((resultado) => {
          this.hideLoading();

          switch(resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.fechar();
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
          }
        }).catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível comunicar-se com o servidor");
        });
    },
    gravarObservacaoDoImovel(payload) {
      payload.imovel = { id: this.imovel.id };
        
      this.showLoading();
      this.gravarObservacaoImovel(payload)
      .then((resultado) => {
        this.hideLoading();

        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.fechar();
            break;
          case "FALHA":
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível comunicar-se com o servidor");
      });
    },
    gravarObservacoesDaVenda(payload) {
      payload.venda = { id: this.venda.id };

      this.showLoading();
      this.gravarObservacaoVenda(payload)
        .then(resultado => {
          this.hideLoading();

          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.fechar();
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
          }
        })
        .catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível comunicar-se com o servidor");
        });
    },
    open(){
      if(this.observacaoSelecionada != undefined) {
        this.observacao = this.observacaoSelecionada;
      } else {
        this.observacao = {
          dataHora: Util.agora(),
          descricao: "",
          assunto: "",
          usuario: ""
        };

        this.observacao.usuario = this.usuarioLogado;
      }
    },
    fechar() {
      this.$emit("close");
    }
  }
};
</script>

<style>
.obs-form-item .el-form-item__content {
  height: 100% !important;
}
.obs-text-area .el-textarea__inner,
.obs-text-area .el-textarea__inner:hover,
.obs-text-area .el-textarea__inner:focus {
  height: 100% !important;
}
</style>

